import { createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { ILogicErrorInterface, IstateMyCar } from './mycar-types';
import { getContractByGuid, saveAgreement } from './mycar-api';
import { isErrorInterface, isAxiosErr } from './utils';

const initial: IstateMyCar = {
  contract: {
    data: null,
    error: null,
    pending: false,
  },
  agreement: {
    data: null,
    error: null,
    pending: false,
  },
};

export const myCarSlice = createSlice({
  name: 'myCarSlice',
  initialState: initial,
  reducers: {},
  extraReducers: (builder) => {
    builder

      /** **************************************
       * GET CONTRACT INFO
       *************************************** */
      .addCase(getContractByGuid.pending, (state) => {
        state.contract.pending = true;
        state.contract.error = null;
      })
      .addCase(getContractByGuid.fulfilled, (state, action) => {
        if (action.payload.error !== null) {
          // проверка наличия логических ошибок с бэка
          if (isErrorInterface(action.payload.error)) {
            const err: ILogicErrorInterface = action.payload.error;
            state.contract.data = null;
            state.contract.pending = false;
            state.contract.error = err.message;
          } else {
            state.contract.data = action.payload.detail;
            state.contract.pending = false;
            state.contract.error = action.payload.error;
          }
        } else {
          state.contract.data = action.payload.detail;
          state.contract.pending = false;
          state.contract.error = null;
        }
      })
      .addCase(getContractByGuid.rejected, (state, action) => {
        if (action.payload) {
          state.contract.error = action.payload.message;
        }
        state.contract.pending = false;
      })

      /** **************************************
       * Save Agreement
       *************************************** */
      .addCase(saveAgreement.pending, (state) => {
        state.agreement.pending = true;
        state.agreement.error = null;
      })
      .addCase(saveAgreement.fulfilled, (state, action) => {
        console.log('action.payload', action.payload);
        if (action.payload.error !== null) {
          if (isErrorInterface(action.payload.error)) {
            const err: ILogicErrorInterface = action.payload.error;
            console.log('action.payload2', err.message);
            state.agreement.data = null;
            state.agreement.pending = false;
            state.agreement.error = err.message;
          } else {
            state.agreement.data = action.payload.detail;
            state.agreement.pending = false;
            state.agreement.error = action.payload.error;
          }
        } else {
          state.agreement.data = true;
          state.agreement.pending = false;
          state.agreement.error = null;
        }
      })
      .addCase(saveAgreement.rejected, (state, action) => {
        if (action.payload) {
          state.agreement.error = action.payload.message;
        }
        state.agreement.pending = false;
      });
  },
});

export default myCarSlice.reducer;
